import axios from 'axios';
import { API_BASE_URL as BASE_URL } from '../../config/api';

const API_BASE_URL = `${BASE_URL}/api/v1/rice-transactions`;

export const getRiceTransactions = async (lastId) => {
    const response = await axios.get(`${API_BASE_URL}`, {
        params: lastId ? { lastId } : {}
    });
    return response.data; // RiceTransactionResponse
};